namespace Solovis.Reports.Parts {

    export class TabListSubReportControl extends Solovis.Reports.Parts.PartControl {

        public _persistedSettings;
        public printOnly: boolean;
        public _tabListSettings: (() => any[]) | any[];
        public _tabCodeToPersistedSettingsMap: { [tabCode: string]: any };

        public _tabStripContainer: JQuery;
        public _tabStripControl: Solovis.UI.TabStripControl;

        public _activeTabModel: Solovis.UI.TabStripControlTabModel;        

        constructor(options: Solovis.Reports.Parts.PartControlOptions) {
            super(options);

            this._persistedSettings = options.persistedSettings ? options.persistedSettings : null;

            this.dataSets = null;

            this.printOnly = this.settings.printOnly ? true : false;

            this._tabListSettings = this.settings.tabs ? this.settings.tabs : []

            // We maintain a map of tab codes to persisted settings. We don't maintain this on the tabModel
            // because we want to be able to maintain state for a tab code even if the tab goes away and comes back
            // in some scenarios.
            this._tabCodeToPersistedSettingsMap = {};

            // See if we have persisted settings for any of the initial tabs and set that on the tab models.
            if (this._persistedSettings && this._persistedSettings.tabs) {
                for (var tabCode in this._persistedSettings.tabs) {
                    this._tabCodeToPersistedSettingsMap[tabCode] = this._persistedSettings.tabs[tabCode];
                }
            }
        }


        public doInit() {
        }

        public doRender() {
            var self = this;

            if (!this.dataSets) {
                return;
            }

            if (this._tabStripContainer) {
                return;
            }

            // Setup tabs.
            this._tabStripContainer = $("<div>").appendTo(this.container);

            this._tabStripControl = new Solovis.UI.TabStripControl({
                controlHost: this._tabStripContainer,
                tabs: [],

                tabContextMenuItemProvider: () => {
                    return this._getTabHeaderContextMenuItems();
                }
            });
            this._tabStripControl.setAsCurrentControl();
        }

        private _getTabHeaderContextMenuItems() {
            let links = [];

            links.push({
                label: "Export All Tables To Excel",
                click: () => {
                    if (this.reportControl) {
                        Solovis.Reports.Parts.Tables.DataTableHelpers.ExcelWysiwygTableRenderer.exportAllReportTablesToExcel(this.reportControl);
                    }
                }
            });

            links.push({ separator: true });

            links.push({
                label: "Cycle Through All Tabs",
                click: async () => {
                    if (this.reportControl) {
                        var modalPanel = new Solovis.UI.ModalWaitPanel({});
                        modalPanel.show();
                        try {
                            // TODO: We need to add additional option that allows us to do this while ignoring the currently cached contents.
                            let crawler = new Solovis.Reports.Util.SubReportCrawler({
                                reportControl: this.reportControl,
                                allDoneCallback: () => {
                                    Solovis.Site.AlertManager.alert({
                                        text: "Cycle through all tabs complete."
                                    });
                                }
                            });
                            await crawler.start();
                        }
                        finally {
                            modalPanel.dispose();
                        }
                    }
                }
            });

            return links;
        }


        public _updateTabList() {
            var self = this;

            var tabListSettings = null;

            if (typeof this._tabListSettings == "function") {
                tabListSettings = this._tabListSettings.call(this);
            }
            else {
                tabListSettings = this._tabListSettings;
            }

            var tabOptionsList = [];

            $(tabListSettings).each(function (i, tabSettings: any) {
                var tabCode = tabSettings.code ? tabSettings.code : null;
                var tabLabel = tabSettings.label ? tabSettings.label : "Tab";

                if (!tabCode) {
                    console.log("TabListSubReportControl: tab " + i + " has no tabCode");
                }
                else {
                    var tabOptions: Solovis.UI.TabStripControlTabOptions = {
                        code: tabCode,
                        label: tabLabel,
                        custom: tabSettings,

                        init: function () {
                            this.custom = this.tabOptions.custom ? this.tabOptions.custom : {};

                            this.custom.tabControlHost = new Solovis.UI.ControlHost({ container: this.tabContentDiv });
                        },

                        activate: function () {
                            self._handleTabActivate(this);
                        },

                        deactivate: function () {
                            self._handleTabDeactivate(this);
                        },

                        destroy: function () {
                            self._handleTabDestroy(this);
                        }
                    };

                    if (tabSettings.noPadding) {
                        tabOptions.noPadding = true;
                    }

                    tabOptionsList.push(tabOptions);
                }
            });


            // Remember the currently active tabModel.
            var activeTabCode = null;
            var activeTabLabel = null;
            if (this._activeTabModel) {
                activeTabCode = this._activeTabModel.tabCode;
                activeTabLabel = this._activeTabModel.tabOptions.label;
            }
            else {
                // See if we can set the initial active tab.                
                if (this._persistedSettings && this._persistedSettings.activeTabCode) {
                    activeTabCode = this._persistedSettings.activeTabCode;
                }
            }

            // Build map of the new tab options.
            var newTabCodeToIndexMap = {};
            $(tabOptionsList).each(function (i, tabOptions: any) {
                newTabCodeToIndexMap[tabOptions.code] = i;
            });

            // Keep map of the tab codes for preserved tabs, so that we don't recreate those.
            var keptTabCodeToTabModelMap = {};

            // Get the current tab model list.
            var currentTabModelList = this._tabStripControl.getTabModelList();
            var currentTabCodeToIndexMap = {};
            $(currentTabModelList).each(function (i, tabModel: any) {
                currentTabCodeToIndexMap[tabModel.tabCode] = i;

                if (Solovis.isNotNull(newTabCodeToIndexMap[tabModel.tabCode])) {
                    // The tabModel is no longer desired in the new list of tabs, so remove it.
                    var newTabIndex = newTabCodeToIndexMap[tabModel.tabCode];
                    var newTabOptions = tabOptionsList[newTabIndex];

                    // We update the latest persisted settings and then use them for the new tab with the same tabCode (should be same type of report).
                    self._updateTabModelPersistedSettings(tabModel);
                }

                if (tabModel.custom.keepTabBetweenRunsIfActive && tabModel.tabCode == activeTabCode) {
                    // We will keep the tab around and only change the parameters on the report. It is expected that the report type will not change in this scenario.
                    // We will use the new report options though.
                    tabModel.custom.reportOptions = newTabOptions.custom.reportOptions;
                    keptTabCodeToTabModelMap[tabModel.tabCode] = tabModel;
                }
                else {
                    self._tabStripControl.removeTab(tabModel);
                }
            });

            var newTabLabelToTabCodeMap = {};
            $(tabOptionsList).each(function (i, tabOptions: any) {
                var tabCode = tabOptions.code;
                newTabLabelToTabCodeMap[tabOptions.label] = tabCode;

                if (!keptTabCodeToTabModelMap[tabCode]) {
                    // Create a new tab since this is not one that we kept from before.
                    self._tabStripControl.insertTab(tabOptions, i);
                }
                else {
                    // See if we can update the report parameters.
                    var keptTabModel = keptTabCodeToTabModelMap[tabCode];
                    if (keptTabModel.custom.tabControlHost && keptTabModel.custom.tabControlHost.currentControl) {
                        var tabReportControl = keptTabModel.custom.tabControlHost.currentControl;
                        self._showOrUpdateReportForTab(keptTabModel);
                    }
                }
            });

            if (activeTabCode) {
                if (Solovis.isNotNull(newTabCodeToIndexMap[activeTabCode])) {
                    self._tabStripControl.activateTab(activeTabCode);
                }
                else {
                    // See if we can find a matching label instead.                
                    if (newTabLabelToTabCodeMap[activeTabLabel]) {
                        self._tabStripControl.activateTab(newTabLabelToTabCodeMap[activeTabLabel]);
                    }
                    else {
                        self._tabStripControl.activateTab(0);
                    }
                }
            }
            else {
                self._tabStripControl.activateTab(0);
            }
        }


        public _handleTabActivate(tabModel) {
            this._activeTabModel = tabModel;

            var tabSettings = tabModel.custom;

            if (!tabModel.custom.tabControlHost.currentControl) {
                if (tabSettings.reportOptions) {
                    this._showOrUpdateReportForTab(tabModel);
                }
            }
        }

        public _handleTabDeactivate(tabModel) {
            var tabSettings = tabModel.custom;
            if (tabSettings.clearOnTabDeactivate) {
                try {
                    this._updateTabModelPersistedSettings(tabModel);
                }
                catch (ex) {
                    // We don't want to error in retrieving persisted settings to stop all tabs from functioning.                
                    console.log("Unable to get tab model persisted settings.")
                    console.log(ex);
                }
                tabModel.custom.tabControlHost.setCurrentControl(null);
            }
        }

        public _handleTabDestroy(tabModel) {
            if (tabModel.custom.tabControlHost) {
                tabModel.custom.tabControlHost.setCurrentControl(null);
            }

            if (this._activeTabModel === tabModel) {
                this._activeTabModel = null;
            }
        }

        public updateParameters(newParameters) {
            this.parameters = newParameters;
        }

        public updateDataSets(dataSets) {
            this.dataSets = dataSets;

            if (this.state >= Solovis.UI.BaseControl.ControlState.beforeRender) {
                this.doRender();
            }

            this._handleDataSetChange();
        }

        public _updateTabModelPersistedSettings(tabModel) {
            if (tabModel.tabCode && tabModel.custom.usePersistedSettings) {
                if (tabModel.custom.tabControlHost.currentControl) {
                    var tabReportControl = tabModel.custom.tabControlHost.currentControl;
                    var tabPersistedSettings: any = {};

                    if (tabReportControl.collectPersistedSettings) {
                        tabPersistedSettings.subReport = tabReportControl.collectPersistedSettings();
                    }
                    if (tabReportControl.getSerializedParameterValues) {
                        tabPersistedSettings.parameters = tabReportControl.getSerializedParameterValues();
                    }

                    this._tabCodeToPersistedSettingsMap[tabModel.tabCode] = tabPersistedSettings;
                }
            }
        }

        public _handleDataSetChange() {
            var self = this;

            if (this._tabStripControl) {
                this._updateTabList();
            }
        }

        public _showOrUpdateReportForTab(tabModel) {
            var tabSettings = tabModel.custom;
            var reportOptions = tabSettings.reportOptions;

            var currentSubReportControl = tabModel.custom.tabControlHost ? tabModel.custom.tabControlHost.currentControl : null;
            if (!currentSubReportControl) {
                this._showReport(tabModel.custom.tabControlHost, reportOptions, tabModel, tabSettings.usePersistedSettings);
            }
            else {
                // The report control already exists so we will try to update the parameters.
                try {
                    var reportConfig;

                    if (typeof reportOptions == "function") {
                        reportConfig = reportOptions.call(this);
                    }
                    else {
                        reportConfig = Solovis.deepCopy(reportOptions);
                    }

                    var parameters = reportConfig.parameters;

                    currentSubReportControl.setParameterValues(parameters);
                }
                catch (error) {
                    console.log("TabListSubReportControl: _showOrUpdateReportForTab error");
                    console.log(error);
                }
            }
        }

        public _showReport(controlHost, reportOptions, tabModel, usePersistedSettings) {
            var self = this;

            var currentSubReportControl = controlHost.currentControl;

            var persistedSettings = null;
            var persistedParameters = null;
            var persistedSubReportSettings = null;

            if (usePersistedSettings) {
                if (currentSubReportControl) {
                    persistedSettings = null;
                    persistedSubReportSettings = currentSubReportControl.collectPersistedSettings();
                    persistedParameters = currentSubReportControl.getSerializedParameterValues();
                }
                else {
                    var tabPersistedSettings = this._tabCodeToPersistedSettingsMap[tabModel.tabCode];
                    if (tabPersistedSettings) {
                        persistedSubReportSettings = tabPersistedSettings.subReport;
                        persistedParameters = tabPersistedSettings.parameters;
                    }
                }
            }

            try {
                var reportConfig;

                if (typeof reportOptions == "function") {
                    reportConfig = reportOptions.call(this);
                }
                else {
                    reportConfig = Solovis.deepCopy(reportOptions);
                }

                if (usePersistedSettings && persistedParameters) {
                    // Any parameters that are not explicitly set should be restored
                    if (!reportConfig.parameters) {
                        reportConfig.parameters = Solovis.deepCopy(persistedParameters);
                    }
                    else {
                        for (var paramName in persistedParameters) {
                            if (typeof reportConfig.parameters[paramName] === "undefined") {
                                // Parameter not explicitly set, so use the persisted value.
                                reportConfig.parameters[paramName] = Solovis.deepCopy(persistedParameters[paramName]);
                            }
                        }
                    }
                }

                if (reportConfig) {
                    reportConfig.printMode = this.printMode;
                    reportConfig.parentReportControl = this.reportControl;
                    reportConfig.persistedSettings = persistedSubReportSettings;                    
                    reportConfig.reportConfigSectionClass = "tabbed-report-config-section";

                    // See if we should adjust first auto-run report options.
                    let parentRunOptions = this.reportControl.getActiveRunReportOptions();
                    let doNotUseCache = !!(parentRunOptions && parentRunOptions.doNotUseCache);
                    if (doNotUseCache && reportConfig.autoRun) {
                        if (!reportConfig.autoRunReportOptions) {
                            reportConfig.autoRunReportOptions = {};
                        }
                        reportConfig.autoRunReportOptions.doNotUseCache = true;
                    }

                    var subReportControl = new Solovis.Reports.ReportControl(reportConfig);

                    controlHost.setCurrentControl(subReportControl);
                }
                else {
                    controlHost.setCurrentControl(null);
                }
            }
            catch (error) {
                console.log("TabListSubReportControl: _showReport error");
                console.log(error);
            }
        };

        public getPersistedSettings() {
            var tabListSettings = {};

            var currentTabModelList = null;
            if (this._tabStripControl) {
                currentTabModelList = this._tabStripControl.getTabModelList();
            }

            for (var tabCode in this._tabCodeToPersistedSettingsMap) {
                tabListSettings[tabCode] = this._tabCodeToPersistedSettingsMap[tabCode];
            }

            $(currentTabModelList).each(function (i, tabModel: any) {
                if (tabModel.tabCode && tabModel.custom.usePersistedSettings) {
                    if (tabModel.custom.tabControlHost.currentControl) {
                        var tabReportControl = tabModel.custom.tabControlHost.currentControl;

                        var tabPersistedSettings: any = {};

                        if (tabReportControl.collectPersistedSettings) {
                            tabPersistedSettings.subReport = tabReportControl.collectPersistedSettings();
                        }
                        if (tabReportControl.getSerializedParameterValues) {
                            tabPersistedSettings.parameters = tabReportControl.getSerializedParameterValues();
                        }

                        tabListSettings[tabModel.tabCode] = tabPersistedSettings;
                    }
                }
            });

            var persistedSettings: any = {};
            persistedSettings.tabs = tabListSettings;

            var activeTabModel = null;
            if (this._tabStripControl) {
                activeTabModel = this._tabStripControl.getActiveTabModel();
            }

            if (activeTabModel && activeTabModel.tabCode) {
                persistedSettings.activeTabCode = activeTabModel.tabCode;
            }

            return persistedSettings;
        }

        public doDestroy() {
            if (this._tabStripControl) {
                this._tabStripControl.controlHost.setCurrentControl(null);
                this._tabStripControl = null;
            }
        }


        public getTabCount() {
            if (this._tabStripControl) {
                return this._tabStripControl.getTabCount();
            }
            else {
                return 0;
            }
        }

        public activateTabByIndex(tabIndex) {
            if (this._tabStripControl) {
                return this._tabStripControl.activateTab(tabIndex);
            }
        }

        public tryGetTabLabelByIndex(tabIndex) {
            let tabModel = this._tabStripControl._tabModelList[tabIndex];
            if (tabModel && tabModel.custom) {
                return tabModel.custom.label;
            }

            return null;
        }

        public tryGetTabSubReportControlByIndex(tabIndex): Solovis.Reports.ReportControl {
            let tabModel = this._tabStripControl._tabModelList[tabIndex];
            if (tabModel && tabModel.custom) {
                let tabControlHost = tabModel.custom.tabControlHost;
                if (tabControlHost) {
                    let currentControl = tabControlHost.currentControl;
                    if (currentControl instanceof Solovis.Reports.ReportControl) {
                        return currentControl;
                    }
                }
            }

            return null;
        }
    }

}
